export const N_APP_DTC = 'N-APP-DTC'
export const N_APP_FAULT = 'N-APP-FAULT'
export const N_CAN = 'N-CAN'
export const N_FUEL_LEVEL_DATA = 'N-FUEL-LEVEL-DATA'
export const N_FUEL_LEVEL_CFG = 'N-FUEL-LEVEL-CFG'
export const N_TEMP_LEVEL_CFG = 'N-TEMP-LEVEL-CFG'
export const N_LIGHTMONITOR = 'N-LIGHTMONITOR'
export const N_MAP = 'N-MAP'
export const N_MLOGIC = 'N-MLOGIC'
export const N_MLOGIC2 = 'N-MLOGIC2'
export const N_PLC = 'N-PLC'
export const N_PREFLIGHT = 'N-PREFLIGHT'
export const N_PREFLIGHT2 = 'N-PREFLIGHT2'
export const N_PREFLIGHT3 = 'N-PREFLIGHT3'
export const N_PRIORITY = 'N-PRIORITY'
export const N_SLOTCOPY = 'N-SLOTCOPY'
export const N_SLOTINIT = 'N-SLOTINIT'
export const N_SSADDRESS = 'N-SSADDRESS'
export const N_STALKSWITCH = 'N-STALKSWITCH'
export const N_SUBCONFIG = 'N-SUBCFG'
export const N_SUBDATA = 'N-SUBDATA'
export const N_TEMP_LEVEL_DATA = 'N-TEMP-LEVEL-DATA'
export const N_TIMER = 'N-TIMER'
export const N_USER_DTC = 'N-USER-DTC'
export const N_USER_FAULT = 'N-USER-FAULT'
export const O_CAN = 'O-CAN'
export const O_FAULT = 'O-FAULT'
export const O_MAP = 'O-MAP'
export const O_MLOGIC = 'O-MLOGIC'
export const O_SLOTCOPY = 'O-SLOTCOPY'
export const O_SLOTINIT = 'O-SLOTINIT'
export const O_TIMER = 'O-TIMER'
export const S_CANSLOTS = 'S-CANSLOTS'
export const S_MAPSLOTS = 'S-MAPSLOTS'
export const S_MEMORY = 'S-MEMORY'
export const S_TIMERSLOTS = 'S-TIMERSLOTS'
export const S_MLOGICSLOTS = 'S-MLOGICSLOTS'
export const S_SLOTINITSLOTS = 'S-SLOTINITSLOTS'
export const N_POWERDOWN = 'N-POWERDOWN'
export const N_Modal = 'N-Modal'
export const N_VIN = 'N-VIN'
export const N_VERSION = 'N-VERSION'
export const N_CANSIZE = 'N-CANSIZE'
export const N_RPSIZE = 'N-RPSIZE'
export const N_RPLOC = 'N-RPLOC'
export const N_EFFORT_CONTROL_DATA = 'N-EFFORT-CONTROL-DATA'
export const N_ANALOG_SENSOR_8BIT_DATA = 'N-ANALOG-SENSOR-8BIT-DATA'
export const N_ANALOG_SENSOR_16BIT_DATA = 'N-ANALOG-SENSOR-16BIT-DATA'
export const N_ANALOG_SENSOR_32BIT_DATA = 'N-ANALOG-SENSOR-32BIT-DATA'
export const N_EFFORT_CONTROL_CFG = 'N-EFFORT-CONTROL-CFG'
export const N_ANALOG_SENSOR_8BIT_CFG = 'N-ANALOG-SENSOR-8BIT-CFG'
export const N_ANALOG_SENSOR_16BIT_CFG = 'N-ANALOG-SENSOR-16BIT-CFG'
export const N_ANALOG_SENSOR_32BIT_CFG = 'N-ANALOG-SENSOR-32BIT-CFG'
export const N_SUBCONFIG_BITMASK = 'bitmask'
export const N_SUBCONFIG_BOOLEAN = 'boolean'

export const editableSPsArray = [
  O_MLOGIC,
  N_MLOGIC,
  N_MLOGIC2,
  N_PLC,
  O_SLOTCOPY,
  N_SLOTCOPY,
  O_TIMER,
  N_TIMER,
  O_MAP,
  N_MAP,
]
export const editableSPsSet = new Set(editableSPsArray)

export const mLogics = new Set([O_MLOGIC, N_MLOGIC, N_MLOGIC2])
export const CAN_SET = new Set([N_CAN, O_CAN])
